import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Snackbar, useMediaQuery, useTheme } from "@material-ui/core";

// Components
import ErrorMessages from "./ErrorMessages.js";
import SucessMessages from "./SucessMessages.js";

// Styles
import GlobalSnackbarAlertStyle from "../../assets/styles/materialUI/global/GlobalSnackbarAlertStyle.js";

// Providers
import { useLanguage } from "../../contexts/languageContext";

const AlertComponent = ({
	errors = null,
	messages = null,
	setError,
	setMessage,
	sucessAlertTitle,
	errorAlertTitle,
}) => {
	const theme = useTheme();
	const { t } = useTranslation();
	const { direction } = useLanguage();
	const classes = GlobalSnackbarAlertStyle();
	const isXs = useMediaQuery(theme.breakpoints.down("xs"));
	const [openSnacSuccess, setOpenSnacSuccess] = useState(false);
	const [openSnacError, setOpenSnacError] = useState(false);

	const closeSucessMessages = (_, reason) => {
		if (reason === "clickaway") {
			return;
		}
		setMessage(null);
	};

	const closeErrorMessages = (_, reason) => {
		if (reason === "clickaway") {
			return;
		}
		setError(null);
	};

	const renderErrors = () => {
		if (errors?.length === 0) return <Grid />;
		return (
			<Grid>
				<ErrorMessages
					openSnacError={openSnacError}
					setOpenSnacError={setOpenSnacError}
					errors={errors}
					errorAlertTitle={errorAlertTitle || t("alerts.errorTitle")}
					classes={classes}
					closeErrorMessages={closeErrorMessages}
				/>
			</Grid>
		);
	};

	const renderMessages = () => {
		if (messages?.length === 0) return <Grid />;
		return (
			<Grid>
				<SucessMessages
					openSnacSuccess={openSnacSuccess}
					setOpenSnacSuccess={setOpenSnacSuccess}
					messages={messages}
					classes={classes}
					sucessAlertTitle={sucessAlertTitle || t("alerts.successTitle")}
					closeSucessMessages={closeSucessMessages}
				/>
			</Grid>
		);
	};

	const hasErrors = !!(errors && errors.length > 0);
	const hasMessages = !!(messages && messages.length > 0);
	const open = hasErrors || hasMessages;

	const anchorOrigin = isXs
		? { vertical: "bottom", horizontal: "center" }
		: { vertical: "bottom", horizontal: direction == "ltr" ? "right" : "left" };

	if (!open) return <Grid />;

	return (
		<Grid className={classes.snackbar} dir={direction}>
			<Snackbar
				anchorOrigin={anchorOrigin}
				open={open}
				key={`${anchorOrigin.vertical}-${anchorOrigin.horizontal}`}
			>
				<Grid className={classes.alertGroup} role="region" aria-live={hasErrors ? "assertive" : "polite"}>
					{hasErrors && renderErrors()}
					{hasMessages && renderMessages()}
				</Grid>
			</Snackbar>
		</Grid>
	);
};

export default AlertComponent;
